import LoanQuoteForm from './components/LoanQuoteForm';

function App({ formType, showTabs, defaultTab, disableSubmission, supportPhone }) {
    return (
        <div className="container">
            <LoanQuoteForm
                formType={formType}
                showTabs={showTabs}
                defaultTab={defaultTab}
                disableSubmission={disableSubmission}
                supportPhone={supportPhone}
            />
        </div>
    );
}

export default App;
